export const betaVendors = ['fake.beta.vendor.com'];
